import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../../components/auth/useAuth'
import { Link } from 'react-router-dom'

export default function Dashboard() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()

    return (
        <>
            <div className="mb-4">
                <h1 className="h3">{t('admin.dashboard.welcome')}, {clientauth?.username}</h1>
                <p className="text-muted mt-2" style={{ fontSize: '15px' }}>{t('admin.dashboard.subtitle')}</p>
            </div>

            <Row className="g-4">
                <Col xs={12} md={6} lg={4}>
                    <Link to="/admin/users" className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: 'var(--primary-50)', color: 'var(--primary)' }}>
                                <i className="fas fa-users"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.users')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageUsers')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <Link to="/admin/products" className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: '#EEF2FF', color: '#4F46E5' }}>
                                <i className="fas fa-barcode"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.products')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageProducts')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <Link to="/admin/departments" className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: '#F0FDF4', color: '#16A34A' }}>
                                <i className="fas fa-building"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.departments')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageDepartments')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <Link to="/admin/delegations" className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: '#E0F2FE', color: '#0284C7' }}>
                                <i className="fas fa-warehouse"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.delegations')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageDelegations')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <Link to="/admin/product-states" className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: '#FFE4E6', color: '#E11D48' }}>
                                <i className="fas fa-tags"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.productStates')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageProductStates')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <Link to="/admin/product-templates" className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: '#FEF3C7', color: '#D97706' }}>
                                <i className="fas fa-layer-group"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.productTemplates')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageTemplates')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <Link to="/admin/chatbot" className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: '#F3E8FF', color: '#9333EA' }}>
                                <i className="fas fa-comment-dots"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.chatbot')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageChatbot')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
            </Row>
        </>
    )
}
